import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}

export const Link: React.FC<LinkProps> = ({ href, children, className, onClick, target, rel }) => {
  return (
    <RouterLink to={href} className={className} onClick={onClick} target={target} rel={rel}>
      {children}
    </RouterLink>
  );
};
